import { page_num } from '@/config/dataMap'
import { clientReport, callClient } from "@/utils/client";

export default {
  mounted () {
    this.listenScroll()
    this.report({type: 'show'})
  },
  methods: {
    toTop () {
      const _parent = document.querySelector('.spread-scroll')
      _parent.scrollTop = 0
    },
    close () {
      this.report({type: 'operate', click: 1})
    },
    changePay (obj) {
      this.report({type: 'operate', hover: obj.idx})
    },
    loginReport ({idx}) {
      this.report({type: 'operate', click: idx})
    },
    toUserCenter () {
      this.$router.push('/')
      this.report({type: 'operate', click: 8})
      this.report({type: 'source'})
      callClient({type: 'spreadToCenter', query: {}})
    },

    renewReport (bool) {
      this.report({type: 'operate', click: bool ? 11 : 10})
    },
    toXieyi () {
      this.report({type: 'operate', click:12 })
    },

    reportType ({idx}) {
      this.report({type: 'operate', click: idx+12})
    },
    reportToAliPay () {
      this.report({
        type: 'operate',
        click: 15
      })
    },

    report ({type, click=0, hover=0, content=0, sub_mode=this.$refs['payModule'].sub_mode}) {
      const page_show = page_num[this.$route.fullPath]
      switch(type) {
        case 'show': clientReport(2, page_show); break
        case 'operate': clientReport(1, page_show, click, hover, sub_mode); break
        case 'content': clientReport(3, page_show, content);  break
        case 'source': clientReport(4, page_show + 10); break
      }
    },
    
    listenScroll () {
      const _parent = document.querySelector('.spread-scroll'), _parentHeight = _parent.clientHeight
      const listenDom = document.querySelectorAll('.item')
      let positionArr = []
      for (let i = 0; i < listenDom.length; i++) {
        positionArr.push(listenDom[i].offsetTop - _parentHeight)
      }
      let fn = () => {
        let scrollTop = _parent.scrollTop
        for (let i = 0; i < positionArr.length; i++) {
          if (positionArr[i] && scrollTop > positionArr[i] ) {
            this.report({type: 'content', content: i + 1})
            positionArr[i] = false
          }
        }
      }
      fn()
      _parent.addEventListener('scroll', (e) => {
        fn()
      })
    }
  }
}